export default __webpack_public_path__ + "4aab7d2977a174a2179f037619767af8.png";